"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var react_1 = tslib_1.__importDefault(require("react"));
var root_1 = require("./styled/root");
var Text = function (_a) {
    var __UIScope = _a.__UIScope, _b = _a.element, element = _b === void 0 ? 'span' : _b, children = _a.children, className = _a.className, scale = _a.scale, font = _a.font, align = _a.align, linkStyle = _a.linkStyle, innerRef = _a.innerRef, _m = _a.m, _mb = _a.mb, _ml = _a.ml, _mr = _a.mr, _mt = _a.mt, _mx = _a.mx, _my = _a.my, _p = _a.p, _pb = _a.pb, _pl = _a.pl, _pr = _a.pr, _pt = _a.pt, _px = _a.px, _py = _a.py, rest = tslib_1.__rest(_a, ["__UIScope", "element", "children", "className", "scale", "font", "align", "linkStyle", "innerRef", "m", "mb", "ml", "mr", "mt", "mx", "my", "p", "pb", "pl", "pr", "pt", "px", "py"]);
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'Text',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    return (react_1.default.createElement(root_1.Root, tslib_1.__assign({ as: element, className: rootClasses, scale: scale, font: font, align: align, linkStyle: linkStyle, ref: innerRef }, rest), children));
};
var TextWithSpace = (0, ui_helper_with_space_1.withSpace)(Text);
exports.Text = TextWithSpace;
//# sourceMappingURL=text.js.map